// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"87.504\" height=\"45.479\" viewBox=\"0 0 87.504 45.479\"> <path data-name=\"Path 2\" d=\"M0,0,1.037,41.068a4,4,0,0,0,4.033,3.9L87,44.272\" transform=\"translate(0.5 0.013)\" fill=\"none\" stroke=\"#ed0206\" stroke-miterlimit=\"10\" stroke-width=\"1\"/> </svg> ";
// Exports
module.exports = code;